import { call, put } from 'redux-saga/effects';

import request from './request';
import {
  createSettingEmailsFailed,
  createSettingEmailsRequested,
  createSettingEmailsSucceeded,
  updateSettingEmailsFailed,
  updateSettingEmailsRequested,
  updateSettingEmailsSucceeded,
  fetchSettingEmailsFailed,
  fetchSettingEmailsRequested,
  fetchSettingEmailsSucceeded,
} from '../../../actions';
import api from '../../../api';

export function* createSettingEmailsRequest(data) {
  yield put(createSettingEmailsRequested(data));

  try {
    const { item } = yield call(request, api.createSettingEmails, data);

    const action = createSettingEmailsSucceeded(item);

    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = createSettingEmailsFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* updateSettingEmailsRequest(id, data) {
  yield put(updateSettingEmailsRequested(id, data));

  try {
    const { item } = yield call(request, api.updateSettingEmails, id, data);

    const action = updateSettingEmailsSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = updateSettingEmailsFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* fetchSettingEmailsRequest() {
  yield put(fetchSettingEmailsRequested());

  try {
    const data = yield call(request, api.getSettingEmails);

    const action = fetchSettingEmailsSucceeded(data);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = fetchSettingEmailsFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}
